import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 3.5V16.5C0 16.8978 0.158035 17.2794 0.43934 17.5607C0.720644 17.842 1.10218 18 1.5 18H10L9.55 18.89C9.38442 19.2232 9.12917 19.5036 8.81295 19.6997C8.49674 19.8958 8.13208 19.9998 7.76 20H7.5C7.36739 20 7.24021 20.0527 7.14645 20.1464C7.05268 20.2402 7 20.3674 7 20.5V21.5C7 21.6326 7.05268 21.7598 7.14645 21.8536C7.24021 21.9473 7.36739 22 7.5 22H16.5C16.6326 22 16.7598 21.9473 16.8536 21.8536C16.9473 21.7598 17 21.6326 17 21.5V20.5C17 20.3674 16.9473 20.2402 16.8536 20.1464C16.7598 20.0527 16.6326 20 16.5 20H16.24C15.8679 19.9998 15.5033 19.8958 15.187 19.6997C14.8708 19.5036 14.6156 19.2232 14.45 18.89L14 18H22.5C22.8978 18 23.2794 17.842 23.5607 17.5607C23.842 17.2794 24 16.8978 24 16.5V3.5C24 3.10218 23.842 2.72064 23.5607 2.43934C23.2794 2.15804 22.8978 2 22.5 2H1.5C1.10218 2 0.720644 2.15804 0.43934 2.43934C0.158035 2.72064 0 3.10218 0 3.5ZM2 14H22V4H2V14Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgImacOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgImacOutline;
